import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact'
import { InputText } from 'primereact/inputtext'
import { MultiSelect } from 'primereact/multiselect'
import { Chips } from 'primereact/chips'


import { getRoles } from '../../../API/IT/Roles/RolesRequests'
import { getUsuarios, getUsuariosActivos } from '../../../API/IT/Usuarios/UsersRequests'
import { changeListaCorreo } from '../../../API/IT/ListaCorreos/ListaCorreosRequests'

import Card from '../../../Base/Components/Card/Card'
import Loader from '../../../Base/Components/Loader/Loader'
import { toastShow } from '../../../Base/Services/ToastService'
import { useForm } from '../../../Base/Hooks/useForm'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext'

const CRUDListaCorreos = ({ show, setShow, getInfoTable, listaEdit }) => {


    const toast = useRef(null)
    const { config } = useContext(ConfigContext);
    const [roles, setRoles] = useState([]);
    const [users, setUsers] = useState([]);
    const [desti, setDesti] = useState('');
    const [CC, setCC] = useState('');
    const [CCo, setCCo] = useState('');
    const [loading, setLoading] = useState(false);

    const initialValues ={
        IdListaCorreo: -1,
        Asunto: '',
        Destinatarios: [],
        IdUsersDestinatarios: [],
        IdRolDestinatarios: [],
        CC: [],
        IdUserCC: [],
        IdRolCC: [],
        CCo: [],
        IdUserCCo: [],
        IdRolCCo: []
    }

    const {values, handleInputChange, setValues, error, setError, resetForm } = useForm(initialValues)


    const onHide = () => {
        setShow(false)
        getInfoTable()
    }


    const getInfo = async () => {
        setLoading(true);
        const r = await getRoles();
        const u = await getUsuariosActivos();
        setRoles(r);
        setUsers(u);
        setLoading(false);
    }


    const guardarLista = async () => {
        setLoading(true);
        const t = {
            IdListaCorreo: values.IdListaCorreo,
            Asunto: values.Asunto.length > 0 ? values.Asunto.toString() : null,

            Destinatarios: values.Destinatarios.length > 0 ? values.Destinatarios.toString() : null,
            IdUsersDestinatarios: values.IdUsersDestinatarios.length > 0 ? values.IdUsersDestinatarios.map(e => e.idUser).toString() : null,
            IdRolDestinatarios: values.IdRolDestinatarios.length > 0 ? values.IdRolDestinatarios.map(e => e.IdRol).toString() : null,

            CC: values.CC.length > 0 ? values.CC.toString() : null,
            IdUserCC: values.IdUserCC.length > 0 ? values.IdUserCC.map(e => e.idUser).toString() : null,
            IdRolCC: values.IdRolCC.length > 0 ? values.IdRolCC.map(e => e.IdRol).toString() : null,

            CCo: values.CCo.length > 0 ? values.CCo.toString() : null,
            IdUserCCo: values.IdUserCCo.length > 0 ? values.IdUserCCo.map(e => e.idUser).toString() : null,
            IdRolCCo: values.IdRolCCo.length > 0 ? values.IdRolCCo.map(e => e.IdRol).toString() : null,

            DestinatariosMail: desti,
            CCMail: CC,
            CCoMail: CCo
        }

        const a = await changeListaCorreo(t);
        console.log({ a });
        if (a.length > 0) {

            // setValues({
            //     IdListaCorreo: a[0].IdListaCorreo,
            //     Asunto: a[0].Asunto,
            //     Destinatarios: a[0].Destinatarios ? a[0].Destinatarios.split(',').map(e => parseInt(e)) : [],
            //     IdUsersDestinatarios: a[0].IdUsersDestinatarios ? a[0].IdUsersDestinatarios.split(',').map(e => parseInt(e)) : [],
            //     IdRolDestinatarios: a[0].IdRolDestinatarios ? a[0].IdRolDestinatarios.split(',').map(e => parseInt(e)) : [],
            //     CC: a[0].CC ? a[0].CC.split(',').map(e => parseInt(e)) : [],
            //     IdUserCC: a[0].IdUserCC ? a[0].IdUserCC.split(',').map(e => parseInt(e)) : [],
            //     IdRolCC: a[0].IdRolCC ? a[0].IdRolCC.split(',').map(e => parseInt(e)) : [],
            //     CCo: a[0].CCo ? a[0].CCo.split(',').map(e => parseInt(e)) : [],
            //     IdUserCCo: a[0].IdUserCCo ? a[0].IdUserCCo.split(',').map(e => parseInt(e)) : [],
            //     IdRolCCo: a[0].IdRolCCo ? a[0].IdRolCCo.split(',').map(e => parseInt(e)) : [],
            // })
            toastShow(toast, 'success', 'Guardado')
            setTimeout(() => {
                onHide()
            }, 1200);
            getInfoTable()

        }
        //    console.log({a});
        setLoading(false)
    }

    useEffect(() => {
        getInfo()
    }, [])

    const verificarMail = (mail) => {
        if (mail) {
            if (mail.includes('@')) {
                return mail
            }
        }
        return null;
    }


    useEffect(() => {
        // DESTINATARIOS
        let destinatariosT = []
        let CCT = []
        let CCoT = []


        values.IdUsersDestinatarios.forEach((user) => {
            const t = verificarMail(users.filter(u => u.idUser === user.idUser)[0]?.Mail);
            if (t) {
                destinatariosT.push(t)
            }
        })



        values.IdRolDestinatarios.map(rol => {
            return users.filter(u => u.IdRol === rol.IdRol).forEach(u => {
                const t = verificarMail(u.Mail);
                if (t)
                    destinatariosT.push(t);
            })
        })



        if (values.Destinatarios) {
            values.Destinatarios.forEach(dest => {
                const t = verificarMail(dest);
                if (t) destinatariosT.push(t);
            });
        }


        // CC
        values.IdUserCC.forEach((user) => {
            const t = verificarMail(users.filter(u => u.idUser === user.idUser)[0]?.Mail);
            if (t) {
                CCT.push(t)
            }
        })

        values.IdRolCC.map(rol => {
            return users.filter(u => u.IdRol === rol.IdRol).forEach(u => {
                const t = verificarMail(u.Mail)
                if (t) {
                    CCT.push(t);
                }
            })
        })

        if (values.CC) {
            values.CC.forEach(dest => {
                const t = verificarMail(dest);
                if (t) CCT.push(t);
            });
        }


        // CCo
        values.IdUserCCo.forEach((user) => {
            const t = verificarMail(users.filter(u => u.idUser === user.idUser)[0]?.Mail);
            if (t) {
                CCoT.push(t)
            }
        })

        values.IdRolCCo.forEach(rol => {
            return users.filter(u => u.IdRol === rol.IdRol).forEach(u => {
                const t = verificarMail(u.Mail);
                if (t) {
                    CCoT.push(t)
                }
            })
        })

        if (values.CCo) {
            values.CCo.forEach(dest => {
                const t = verificarMail(dest);
                if (t) CCoT.push(t);
            });
        }

        // console.log(destinatariosT, CCT, CCoT);
        setDesti(destinatariosT.toString());
        setCC(CCT.toString());
        setCCo(CCoT.toString());


    }, [values])


    useEffect(() => {
        if(listaEdit){
            const val = {
                ...listaEdit,
                IdUsersDestinatarios: listaEdit.IdUsersDestinatarios ? users.filter(u => listaEdit.IdUsersDestinatarios.includes(u.idUser)) : [],
                IdRolDestinatarios: listaEdit.IdRolDestinatarios ? roles.filter(r => listaEdit.IdRolDestinatarios.includes(r.IdRol)) : [],
                IdUserCC: listaEdit.IdUserCC ? users.filter(u => listaEdit.IdUserCC.includes(u.idUser)) : [],
                IdRolCC: listaEdit.IdRolCC ? roles.filter(r => listaEdit.IdRolCC.includes(r.IdRol)) : [],
                IdUserCCo: listaEdit.IdUserCCo ? users.filter(u => listaEdit.IdUserCCo.includes(u.idUser)) : [],
                IdRolCCo: listaEdit.IdRolCCo ? roles.filter(r => listaEdit.IdRolCCo.includes(r.IdRol)) : [],
            }
            setValues(val);
        }else{
            setValues({
                IdListaCorreo: -1,
                Asunto: '',
                Destinatarios: [],
                IdUsersDestinatarios: [],
                IdRolDestinatarios: [],
                CC: [],
                IdUserCC: [],
                IdRolCC: [],
                CCo: [],
                IdUserCCo: [],
                IdRolCCo: []
            });
        }
    }, [listaEdit, users, roles])


    // console.log(formValues.IdUsersDestinatarios.map((user) => users.filter(u => u.idUser === user)[0].Mail ))

    return (

        <div>
            <Dialog
                visible={show}
                onHide={onHide}
                style={{ width: '80vw' }}
                header={<div className='mt-3'>
                    <h3>Destinatarios</h3>
                    </div>}
                footer={<div>
                    <Button label='Cancelar' className="p-button-secondary" onClick={onHide} loading={loading} />
                    <Button label='Guardar' onClick={guardarLista} />
                </div>}
            >
                <div id='editListaCorreo'>
                    <Toast ref={toast} />
                    <Loader loading={loading} querySelector='#editListaCorreo' />
                    <Card
                        titulo={<h4>Asunto</h4>}
                        contenido={<div className='p-4'>
                            <div className="p-float-label">
                                <InputText
                                    style={{ width: '80%' }}
                                    value={values.Asunto}
                                    name='Asunto'
                                    onChange={handleInputChange}
                                    className={error.Asunto ? "p-invalid" : ""}

                                />
                                {/* <label>Asunto</label> */}
                            </div>
                        </div>}
                    />
                    <Card
                        titulo={<h4>Destinatarios</h4>}
                        contenido={
                            <div>
                            <div className='p-4 d-flex' style={{ justifyContent: 'space-around' }}>

                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdUsersDestinatarios'
                                    value={values.IdUsersDestinatarios}
                                    onChange={handleInputChange}
                                    options={users}
                                    optionLabel='UserName'
                                    filter
                                />
                                <label>Usuarios</label>
                            </div>
                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdRolDestinatarios'
                                    value={values.IdRolDestinatarios}
                                    onChange={handleInputChange}
                                    options={roles}
                                    optionLabel='Rol'
                                    filter
                                />
                                <label>Rol</label>
                            </div>
                            <div className="p-float-label">
                                {/* <MultiSelect style={{ width: 300 }} /> */}
                                <Chips
                                    name='Destinatarios'
                                    value={values.Destinatarios}
                                    style={{ width: 300 }}
                                    onChange={handleInputChange}
                                />
                                <label>Correos Externos</label>
                            </div>
                            </div>
                            </div>
                        }
                    />

                    <Card
                        titulo={<h4>CC</h4>}
                        contenido={<div className='p-4 d-flex' style={{ justifyContent: 'space-around' }}>

                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdUserCC'
                                    value={values.IdUserCC}
                                    onChange={handleInputChange}
                                    options={users}
                                    optionLabel='UserName'
                                    filter
                                />
                                <label>Usuarios</label>
                            </div>
                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdRolCC'
                                    value={values.IdRolCC}
                                    onChange={handleInputChange}
                                    options={roles}
                                    optionLabel='Rol'
                                    filter
                                />
                                <label>Rol</label>
                            </div>
                            <div className="p-float-label">
                                {/* <MultiSelect style={{ width: 300 }} /> */}
                                <Chips
                                    name='CC'
                                    value={values.CC}
                                    style={{ width: 300 }}
                                    onChange={handleInputChange}
                                />
                                <label>Correos Externos</label>
                            </div>

                        </div>}
                    />

                    <Card
                        titulo={<h4>CCo</h4>}
                        contenido={<div className='p-4 d-flex' style={{ justifyContent: 'space-around' }}>

                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdUserCCo'
                                    value={values.IdUserCCo}
                                    onChange={handleInputChange}
                                    options={users}
                                    optionLabel='UserName'
                                    filter
                                />
                                <label>Usuarios</label>
                            </div>
                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdRolCCo'
                                    value={values.IdRolCCo}
                                    onChange={handleInputChange}
                                    options={roles}
                                    optionLabel='Rol'
                                    filter
                                />
                                <label>Rol</label>
                            </div>
                            <div className="p-float-label">
                                {/* <MultiSelect style={{ width: 300 }} /> */}
                                <Chips
                                    name='CCo'
                                    value={values.CCo}
                                    style={{ width: 300 }}
                                    onChange={handleInputChange}
                                />
                                <label>Correos Externos</label>
                            </div>

                        </div>}
                    />

                    <div>
                        <Card
                            titulo={<h4>Lista de Correos</h4>}
                            contenido={<div className='p-4'>
                                <div>
                                    <h5>Destinatario</h5>
                                    <p>
                                        {desti}
                                    </p>
                                </div>
                                <div>
                                    <h5>CC</h5>
                                    <p>
                                        {CC}
                                    </p>
                                </div>
                                <div>
                                    <h5>CCo</h5>
                                    <p>
                                        {CCo}
                                    </p>
                                </div>

                            </div>}
                        />
                    </div>


                </div>

            </Dialog>
        </div>
    )
}

export default CRUDListaCorreos